import { customerTypes } from '@teinor/erp/types/company/customer/customerTypes'
import { FormElement, FormRender } from '../../../forms/FormRenderer/types'
import { CustomerModelTypeAndAddress } from '../../../specificComponents/Customers/types'
import { TwinDictionary } from '../../globals/dictionary'
import { returnClassOfSpanTemplate } from '../../globals/tailwind'
import useTwinTranslation from '../useTwinTranslation'
import useCreateCustomerAndAddress from './useCreateCustomerAndAddress'

interface CreateCustomerAddressProps {
    createAddress: boolean
    handleShowCreateAddress: (val: boolean) => void
    typeCustomerSelected: number | null
    data?: TwinDictionary
}

const useCreateAllCustomerAddresOrWC = ({ createAddress, typeCustomerSelected, handleShowCreateAddress, data }: CreateCustomerAddressProps) => {
    const { t } = useTwinTranslation()
    const { addressFields, addressFieldsCSV } = useCreateCustomerAndAddress({ createAddress, data })
    let specialFields: FormRender<any> = []
    let specialFieldsCSV: FormRender<any> = []
    const specialName: FormElement<keyof CustomerModelTypeAndAddress>[] = []
    const specialNameCSV: FormElement<any>[] = []
    const specialCheckbox: FormElement<keyof CustomerModelTypeAndAddress>[] = []
    if (typeCustomerSelected !== null && parseInt(String(typeCustomerSelected)) !== -1) {
        const parsedTypeCustomerSelected = parseInt(String(typeCustomerSelected))
        if (parsedTypeCustomerSelected === customerTypes['B2B'] || parsedTypeCustomerSelected === customerTypes['contactB2B']) {
            specialName.push(
                {
                    name: 'fiscal_name',
                    label: t('fiscalName', 'Nombre fiscal'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
            )
            specialNameCSV.push(
                {
                    name: 'posFiscalNameColumn',
                    label: t('posFiscalNameColumn', 'Posición columna nombre fiscal'),
                    component: 'InputWithLabelMarginIntegerStateFull',
                },
            )
        }
        if (parsedTypeCustomerSelected === customerTypes['B2C'] || parsedTypeCustomerSelected === customerTypes['contactB2C']) {
            specialName.push({
                name: 'surname',
                label: t('surname', 'Apellidos'),
                component: 'InputWithLabelMargin',
                type: 'text',
            },)
            specialNameCSV.push(
                {
                    name: 'posSurnameColumn',
                    label: t('posSurnameColumn', 'Posición columna apellido'),
                    component: 'InputWithLabelMarginIntegerStateFull',
                },
            )
        }
        specialCheckbox.push(
            {
                name: 'createAddress',
                component: 'CheckboxMargin',
                label: t('createAddress', 'Crear dirección'),
                checked: createAddress,
                className: returnClassOfSpanTemplate(3),
                onChange: (val) => handleShowCreateAddress(val)
            }
        )
        specialFields = addressFields
        specialFieldsCSV = addressFieldsCSV
    }

    return { specialCheckbox, specialName, specialFields, specialNameCSV, specialFieldsCSV }
}


export default useCreateAllCustomerAddresOrWC